import { Link, useNavigate } from 'react-router-dom';
import { categories } from '@/mocks/home';

interface CategoryNavProps {
  activeSlug?: string;
}

export default function CategoryNav({ activeSlug }: CategoryNavProps) {
  const navigate = useNavigate();

  const handleClick = (slug: string) => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    navigate(`/category/${slug}`);
  };

  return (
    <section className="w-full bg-background-50 py-6 md:py-8">
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-center gap-2 md:gap-3 flex-wrap">
          {categories.map((cat) => {
            const isActive = activeSlug === cat.slug;
            return (
              <button
                key={cat.id}
                onClick={() => handleClick(cat.slug)}
                className={`flex items-center gap-2 px-4 py-2.5 rounded-full text-sm font-medium whitespace-nowrap transition-all cursor-pointer ${
                  isActive
                    ? 'bg-primary-500 text-white'
                    : 'bg-background-100 text-foreground-700 hover:bg-primary-50 hover:text-primary-500'
                }`}
              >
                <i className={`${cat.icon} ${isActive ? 'text-white' : 'text-secondary-500'}`}></i>
                {cat.name}
              </button>
            );
          })}
        </div>
      </div>
    </section>
  );
}